__turbopack_context__.v({
  "pane": "ContentPanes-module-scss-module__EZuT8q__pane",
  "paneBlock": "ContentPanes-module-scss-module__EZuT8q__paneBlock",
  "paneCollection": "ContentPanes-module-scss-module__EZuT8q__paneCollection",
  "paneImage": "ContentPanes-module-scss-module__EZuT8q__paneImage",
  "paneText": "ContentPanes-module-scss-module__EZuT8q__paneText",
});
